module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "pt1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_vm._v("EARTH")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("Sufficient unto the day is the evil thereof.")]), _vm._v(" "), _c('div', {
    staticClass: "PEPC-SP"
  }, [_c('p', {
    staticClass: "PEPC"
  }, [_c('span', {
    staticClass: "pepc-CAPS"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ATTHEW")]), _vm._v(" 6:34")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef8734c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 72
// module chunks = 0